import Head from 'next/head';
import { NextPage } from 'next';

import {
  ActionCenterDetails,
  MatchedTargets,
} from '@/core/interfaces/common';
import { wrapper } from '@/core/store/store';

import { TakeActionWidgetV2 } from '@/features/TakeActionWidgetV2';

import { request } from '@/utils/request';
import { fetchActionCenterData } from '@/utils/requestHelpers';

interface WidgetProps {
  actionCenterDetails: ActionCenterDetails;
  nonGeocodedTargets: MatchedTargets;
}

const WidgetV2: NextPage<WidgetProps> = (initialProps: WidgetProps) => {
  const {
    actionCenterDetails,
    nonGeocodedTargets,
  } = initialProps;

  const title = `${actionCenterDetails.headlineConfig.headlineText || 'Take Action'} | ${actionCenterDetails.organization.name}`;

  return (
    <>
      <Head>
        <title key="title">{title}</title>
        <meta
          property="og:title"
          content={title}
        />
        <meta
          property="og:image"
          content={actionCenterDetails.landingPageImage}
        />
      </Head>
      <TakeActionWidgetV2
        actionCenterDetails={actionCenterDetails}
        nonGeocodedTargets={nonGeocodedTargets}
      />
      <script src="/iframeResizer.contentWindow.min.js" />
    </>
  );
};

WidgetV2.getInitialProps = wrapper.getInitialPageProps(() => async ({
  query,
}) => {
  const actionCenterDetails = await fetchActionCenterData(query.uuid);

  let nonGeocodedTargets = null;

  if (actionCenterDetails && !actionCenterDetails.isGeocoded) {
    nonGeocodedTargets = await request
      .get(`/public/act/${query.uuid}/match_targets/`)
      .then(({ data }) => data)
      .catch(error => null);
  }

  return {
    actionCenterDetails,
    nonGeocodedTargets,
  };
});

export default WidgetV2;
